import React from "react";
import "./styles/Key.css";

function Key() {
  return (
    <div className="key--container">
      <h6 className="key--title">Key/Tonaliteti</h6>
      <div className="keys">
        <button>C</button>
        <button>C#</button>
        <button>D</button>
        <button>D#</button>
        <button>E</button>
        <button>F</button>
      </div>
      <div className="keys">
        <button>F#</button>
        <button>G</button>
        <button>G#</button>
        <button>A</button>
        <button>A#</button>
        <button>B</button>
      </div>
    </div>
  );
}

export default Key;
